import React,{useState,useEffect} from "react";
import { IoCloseCircle } from "react-icons/io5";
import { Success, Error } from "./Status";
const DeleteModal = ({ toggleModal, handleToggle, deleteAction,deleteText }) => {
  const { mutate: deleteItem, isSuccess, error:deleteError, isLoading } = deleteAction();
  // MISC STATE
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleDelete = () => {
    deleteItem();
  };



  // EFFECTS
  useEffect(() => {
    if (isSuccess) {
      setSuccess("Item deactivated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [isSuccess]);


  useEffect(() => {
    if (deleteError) {
      const message = deleteError?.response?.data?.message;
      setError(message);
    }
  }, [deleteError]);

  if (toggleModal) {
    return (
      <div className="modal">
        <div className="bg-white relative w-[80vw] md:w-1/2 lg:w-1/3 2xl:w-1/5 p-6 flex flex-col space-y-5 rounded shadow-md ">
        {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
          <p className="text-center text-black font black text-2xl mb-5 whitespace-normal">
            Are you sure 
            <br />
            you want to {deleteText}
          </p>
          <IoCloseCircle
            onClick={handleToggle}
            className="absolute right-3 -top-3 text-red-600 text-2xl self-top cursor-pointer transition-all ease-in-out hover:scale-110"
          />

          <div className="grid grid-cols-2 gap-4">
            <button
              className="text-xl border-2 border-gray-700 text-gray-700 rounded hover:bg-gray-700 hover:text-white"
              onClick={handleToggle}
            >
              Cancel
            </button>
            <button className="text-xl bg-red-600 text-white rounded-lg py-2 hover:bg-red-700" onClick={handleDelete}>
              Yes
            </button>
          </div>
        </div>
      </div>
    );
  }
  return <></>;
};

export default DeleteModal;
